// Libs
import React, { useContext } from "react";

// Utils
import type { SortDirection } from "@mui/material";
import type { TableConfiguration } from "./types";

export interface TableContextType<T = Record<string, unknown>, F = T> {
    conf: TableConfiguration<T, F>;
    activeGroups: string[];
    onGroupToggle: (groupKey: string) => void;
    onColumnSortToggle: (columnKey: string) => void;
    sorts: {
        key: string;
        direction: SortDirection;
        customOrderMapConverter?: Record<string, number>;
    }[];
    lastSortKey: string;
    extraProps?: Record<string, unknown>;
}

const TableContext = React.createContext<TableContextType>(null);

export function useTableContext(): TableContextType {
    return useContext(TableContext);
}

export function TableContextProvider<T, F>({
    children,
    ...otherProps
}: React.PropsWithChildren<TableContextType<T, F>>): JSX.Element {
    return <TableContext.Provider value={otherProps as any}>{children}</TableContext.Provider>;
}
